<template>
  <BusFrontContainer>
    <v-img src="@/assets/busfront1.png" />
    <v-img src="@/assets/busfront2.png" />
  </BusFrontContainer>
</template>

<script>
import { BusFrontContainer } from "./styled";
export default {
  components: {
    BusFrontContainer,
  },
};
</script>

<style>
</style>
